module.exports = __webpack_public_path__ + "img/34.db8fd92a.png";